<template>
  <div class="expandable-text">
    <div
      ref="content"
      :class="{ clamped: !isExpanded }"
      :style="!isExpanded ? { WebkitLineClamp: lines } : {}"
      class="text-content"
    >
      {{ text }}
    </div>
    <div v-if="isClamped" class="mt-2">
      <UiButton 
        type="primary"
        outline
        :icon="isExpanded ? 'chevron-up' : 'chevron-down'"
        :text="isExpanded ? 'Ver Menos' : 'Ver Mais'"
        class="w-full py-3"
        @click="toggle"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick, watch } from 'vue'
import UiButton from './button.vue'

const { text, lines = 3 } = defineProps<{
  text: string
  lines?: number
}>()

const content = ref<HTMLElement | null>(null)
const isExpanded = ref(false)
const isClamped = ref(false)

const toggle = () => {
  isExpanded.value = !isExpanded.value
}
const checkClamping = () => {
  // Aguarda renderização
  nextTick(() => {
    const el = content.value
    if (el) {
      const isOverflowing = el.scrollHeight > el.clientHeight
      isClamped.value = isOverflowing
    }
  })
}

watch(() => text, checkClamping)

onMounted(() => {
  checkClamping()
})
</script>

<style scoped>
.text-content {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
  word-break: break-word;
  transition: max-height 0.3s ease;
}

.clamped {
  -webkit-line-clamp: 3;
}
</style>
